import React from 'react'
import BASEURL from '../../Config/global';
import axios from 'axios';
import { postRequest } from '../../Util/requests';

const ConfigData = [
    {
        "title": "Sound",
        "name": "sound",
        "url": "/api/sounds/soundscategories"
    },
    {
        "title": "Relax & Rest",
        "name": "meditation",
        "url": "/api/meditation/meditationcategories"
    },
    {
        "title": "Stories",
        "name": "stories",
        "url": "/api/stories/storiescategories"
    },
    {
        "title": "Article",
        "name": "article",
        "url": "/api/articles/articlecategories"
    },
    {
        "title": "Featured Mixes",
        "name": "featured_mixes",
        "url": "/api/sounds/mixFeatureCategories"
    },
];

const LinkedCategory = async (id) => {
    const LocalData = {}

    for (const config of ConfigData) {
        const data = await getCategoryDataFromApi(config);
        LocalData[config.name] = data;
    }

    // console.log(LocalData);
    createList(id, LocalData)
}

const selectCategories = (category) => {
    const array = []
    category.map((item) => {
        array.push({
            "category": item?.is_default ? item?.id : null,
            "subcategories": item?.is_default ? selectSubCategories(item?.category_data || item?.subcategories) : []
        })
    })
    return array;
}

const selectSubCategories = (sub_category) => {
    const array = [];
    sub_category?.length > 0 && sub_category?.map((item, index) => {
        if (item?.is_default) {
            array.push(item?.id);
        }
    })
    return array;
}

const getCategoryDataFromApi = async (config) => {
    try {
        const response = await axios.get(
            `${BASEURL + config['url']}`
        );
        if (response.data.data) {
            let selectedCategoryAndSubCategoryItem = [];
            const sortedData = response.data.data.sort(function (a, b) { return a.sequence - b.sequence });
            selectedCategoryAndSubCategoryItem = selectCategories(sortedData);
            return selectedCategoryAndSubCategoryItem;
            // handleSelectedData(selectedCategoryAndSubCategoryItem, config.name);
            // console.log(selectedCategoryAndSubCategoryItem, config.name)
            // console.log(selectedCategoryAndSubCategoryItem)
        } else {
            return [];
        }
    } catch (error) {
        console.error(error);
        return [];
    }


}

const createList = async (id, LocalData) => {
    try {
        const body = {
            "promo_id": id,
            "is_new": false,
            "cats_and_subcats": LocalData
        }
        const response = await postRequest(`/api/user/coupon_cat_sub_cat`, body)
        console.log("Categories Linked to Promo")
        return response;
    } catch (error) {
        console.log(error)
        return {}
    }

}

export { LinkedCategory, selectCategories, selectSubCategories, createList, ConfigData }; 